import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap } from 'rxjs';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { FileTypes } from '../../../../core/models/application';
@Component({
  selector: 'app-template-file-uploader',
  templateUrl: './template-file-uploader.component.html',
  styleUrls: ['./template-file-uploader.component.scss']
})
export class TemplateFileUploaderComponent implements OnInit {

  templateFileForm: UntypedFormGroup = new UntypedFormGroup({    
    fileTypeApp: new UntypedFormControl(null),
    rdp_File: new UntypedFormControl(null),
    vnc_File: new UntypedFormControl(null),
  });
  fileTypes: FileTypes[] = [
    { name: 'RDP File', value: '6' }, { name: 'VNC File', value: '7' }
  ];
  depName = this.data.depName;
  file: File;
  constructor(
    private _deploymentService: DeploymentService,
    public dialogRef: MatDialogRef<TemplateFileUploaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { depName: string },
    private _spinner: NgxSpinnerService,
    private _snackBar: MatSnackBar
 ) { }

  ngOnInit(): void {
  }

  onSubmit() {
    if (!this.file) {
      this._snackBar.open("Please Select File Before Submitting", "Ok", { duration: 5000 })
      return;
    }
    let fileTypeName = this.templateFileForm.value.fileTypeApp.value == "6" ? "rdp" : "vnc";
    this._deploymentService.addDeploymentRdpFile(this.depName, this.file, fileTypeName).subscribe({
      next: (event: HttpResponse<any>) => {
        if (event.status == 200) {
          this._snackBar.open("File Uploaded Succesfully", "OK", { duration: 5000 })

          this.dialogRef.close();
        }
      },
      error: (err: HttpErrorResponse) => {
        this._snackBar.open("Failed To Upload File", 'Ok', {
          duration: 5000
        })
      }
    })
  }

  /*uploadFiles(event, id) {
    let selectedFileType = this.templateFileForm.value.fileTypeApp.value;
    this.file = event.target.files[0];
    switch (selectedFileType) {
      case "6":
        this.templateFileForm.controls['rdp_File'].setValue(this.file.name);
        break;
      case "7":
        this.templateFileForm.controls['vnc_File'].setValue(this.file.name);
        break;
    }
  }*/

  uploadFiles(event, id) {
    if (!this.templateFileForm.value.fileTypeApp) {
      this._snackBar.open(`Please Select File Type To Upload.`, "OK", { duration: 5000 })
      return;
    }
    let selectedFileType = this.templateFileForm.value.fileTypeApp.value;
    this.file = event.target.files[0];
    if (this.file.type.length === 0) {
      let fileName = this.file.name.split(".");
      let fileType = fileName[1];
      if (fileType.toLowerCase() != "rdp" && fileType.toLowerCase() != "vnc") {
        this._snackBar.open(`Please Upload ${selectedFileType == "6" ? "RDP" : "VNC"} File Type.`, "OK", { duration: 5000 })
        return;
      }
    } else {
      if (this.file.type.toLowerCase() != this.file.type.toLowerCase()) {
        this._snackBar.open(`Please Upload ${selectedFileType == "6" ? "RDP" : "VNC"} File Type.`, "OK", { duration: 5000 })
        return;
      }
    }
    switch (selectedFileType) {
      case "6":
        this.templateFileForm.controls['rdp_File'].setValue(this.file.name);
        break;
      case "7":
        this.templateFileForm.controls['vnc_File'].setValue(this.file.name);
        break;
    }
  }

  onFileChange(id) {
  }


  onCancel() {
    this.dialogRef.close();
  }
}
